/* ===================================================================================
   MIcase · ENCABEZADO · comportamiento.
   Extraido el 2026-08-16 del <script> en linea de sections/micase-header.liquid, que
   viajaba entero (~15 KB) dentro del HTML de TODAS las paginas.

   LOS TRES VALORES QUE VIENEN DE LIQUID (el interruptor del realce, el modo del remate
   y su corte) llegan ahora por una isla JSON diminuta,
   <script type="application/json" id="mc-header-datos">, que la seccion pinta justo
   antes de cargar este archivo.

   EL NODO RAIZ se localiza por #mc-header-raiz, un id fijo, en vez de por
   #shopify-section-{{ section.id }}, que obligaba a que este codigo fuese Liquid. Se
   mantiene el respaldo por clase.

   EL CTA se marca desde Liquid y el remate parte del valor seguro que ya imprime el
   servidor. El archivo se carga con defer y no bloquea el analizador.
   =================================================================================== */
(function () {
  var datos = {};
  try {
    var isla = document.getElementById('mc-header-datos');
    if (isla) datos = JSON.parse(isla.textContent) || {};
  } catch (e) {
    console.warn('[MIcase] micase-header: no se pudieron leer los datos de la seccion', e);
  }

  var raiz = function () {
    return document.getElementById('mc-header-raiz') || document.querySelector('.mc-header-wrap');
  };

  /* 1. Encabezado pegajoso. Version propia, no la de Dawn: la de Dawn vive dentro de su
        seccion header y ademas cierra un details-modal sin comprobar que exista. */
  try {
    if (!customElements.get('mc-sticky-header')) {
      customElements.define('mc-sticky-header', class extends HTMLElement {
        connectedCallback() {
          this.tipo = this.getAttribute('data-sticky-type');
          this.header = document.querySelector('.section-header');
          this.alto();
          this.enResize = this.alto.bind(this);
          window.addEventListener('resize', this.enResize);
          if (this.tipo === 'none') return;
          if (this.tipo === 'always') {
            this.header.classList.add('shopify-section-header-sticky');
          }
          this.anterior = window.scrollY;
          this.enScroll = this.scroll.bind(this);
          window.addEventListener('scroll', this.enScroll, { passive: true });
        }
        disconnectedCallback() {
          window.removeEventListener('scroll', this.enScroll);
          window.removeEventListener('resize', this.enResize);
        }
        alto() {
          document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
          var barra = parseInt(getComputedStyle(document.body).getPropertyValue('--height-topbar'), 10) || 0;
          this.umbral = this.offsetHeight + barra;
        }
        scroll() {
          var y = window.scrollY;
          var umbral = this.umbral || this.offsetHeight;
          if (this.tipo === 'always') {
            this.header.classList.toggle('scrolled-past-header', y > umbral);
            this.anterior = y;
            return;
          }
          /* on-scroll-up: se esconde al bajar y vuelve al subir */
          if (y > umbral && y > this.anterior) {
            this.header.classList.add('shopify-section-header-hidden');
            this.header.classList.remove('shopify-section-header-sticky');
          } else if (y > umbral) {
            this.header.classList.add('shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden');
          }
          this.header.classList.toggle('scrolled-past-header', y > umbral);
          this.anterior = y;
        }
      });
    }
  } catch (e) {
    console.warn('[MIcase] micase-header: no se pudo registrar mc-sticky-header', e);
  }

  /* 2. Buscador de movil: el boton lupa lo despliega. */
  try {
    var boton = document.querySelector('.mc-header__icono--buscar');
    var panel = document.getElementById('mc-buscador-movil');
    if (boton && panel) {
      boton.addEventListener('click', function () {
        var abierto = panel.hasAttribute('data-abierto');
        if (abierto) {
          panel.removeAttribute('data-abierto');
          boton.setAttribute('aria-expanded', 'false');
        } else {
          panel.setAttribute('data-abierto', '');
          boton.setAttribute('aria-expanded', 'true');
          var campo = panel.querySelector('input[type="search"]');
          if (campo) campo.focus();
        }
      });
    }
  } catch (e) {
    console.warn('[MIcase] micase-header: el buscador de movil no se pudo enganchar', e);
  }

  /* 3. Esconder o mostrar el contador del carrito segun su numero.
        ESTO NO ACTUALIZA EL CARRITO y no consulta nada: el actualizador vive en otro
        archivo y solo escribe el numero dentro de .mc-header__contador. Aqui unicamente
        se traduce ese numero a visible o escondido, para que quien escriba el numero no
        tenga que acordarse de quitar el atributo hidden. Se vigila el texto, no los
        atributos, asi que poner o quitar hidden no vuelve a disparar esta funcion. */
  try {
    var contador = document.querySelector('[data-mc-contador]');
    if (contador && window.MutationObserver) {
      var pintarContador = function () {
        var n = parseInt((contador.textContent || '').trim(), 10);
        if (!isNaN(n) && n > 0) contador.removeAttribute('hidden');
        else contador.setAttribute('hidden', '');
      };
      pintarContador();
      new MutationObserver(pintarContador).observe(contador, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  } catch (e) {
    console.warn('[MIcase] micase-header: no se pudo vigilar el contador del carrito', e);
  }

  /* 4. Realce al hacer scroll (ajuste realce_scroll).
        Un unico listener pasivo que solo pone o quita un atributo en el envoltorio; todo
        lo visual lo hace el CSS. No se encadena a ningun MutationObserver del tema ni
        depende de que el encabezado sea pegajoso: funciona igual con sticky apagado.
        Si el ajuste esta apagado no se registra nada. */
  try {
    var realceEncendido = datos.realce;
    if (realceEncendido) {
      var envoltorio = raiz();
      if (envoltorio) {
        var pintarRealce = function () {
          if (window.scrollY > 8) envoltorio.setAttribute('data-mc-scroll', '');
          else envoltorio.removeAttribute('data-mc-scroll');
        };
        pintarRealce();
        window.addEventListener('scroll', pintarRealce, { passive: true });
      }
    }
  } catch (e) {
    console.warn('[MIcase] micase-header: el realce al hacer scroll no se pudo activar', e);
  }

  /* 5. REMATE INFERIOR SEGUN EL COLOR DE LO QUE HAY DEBAJO (ajuste remate_modo).
        Ver el comentario largo de assets/micase-header.css para el porque. Aqui va el como.

        COMO SE MIDE. No se busca "la seccion siguiente" en el DOM, porque eso falla en
        cuanto hay una seccion anidada, un contenedor intermedio o el encabezado pegajoso
        flotando sobre la mitad de un bloque. Se mide lo unico que importa de verdad: que
        color hay en el pixel que esta justo debajo del filo del encabezado, ahora mismo,
        con document.elementsFromPoint. Eso resuelve solo el caso del sticky, porque al
        hacer scroll lo que hay debajo cambia y la medida cambia con el.

        Se toman tres muestras a lo ancho (izquierda, centro, derecha) porque una sola
        puede caer encima de un texto, de una imagen o de una columna con fondo propio y
        no representar la seccion. Se promedia lo que se haya podido leer.

        POR QUE LUMA Y NO LUMINANCIA WCAG. La luminancia relativa de WCAG esta pensada
        para calcular contraste y es muy poco lineal: un gris medio #808080 le sale en
        0,22, asi que con un corte en la mitad casi cualquier color acabaria contando
        como oscuro. Aqui no se calcula contraste, se decide "esto se ve claro o se ve
        oscuro", y para eso la luma sencilla va mejor: #808080 sale justo en 0,50.

        HISTERESIS. El corte no es un unico valor sino una franja: para pasar de claro a
        oscuro hay que bajar un poco por debajo del corte, y para volver hay que subir un
        poco por encima. Sin eso, un fondo que caiga justo en el limite haria parpadear
        el remate en cada pixel de scroll. */
  try {
    var remateModo = datos.remate;
    var envRemate = raiz();

    if (remateModo === 'auto' && envRemate && document.elementsFromPoint) {
      var corte = (datos.corte || 50) / 100;
      var margen = 0.05;

      /* Solo se aceptan colores en notacion rgb()/rgba(), que es lo que devuelve
         getComputedStyle en la practica. Cualquier otra notacion (color(srgb ...), por
         ejemplo, donde los canales van de 0 a 1) se descarta en vez de interpretarse mal
         y dar un falso "oscuro". */
      var aRgb = function (txt) {
        if (!txt || txt.indexOf('rgb') !== 0) return null;
        var n = txt.match(/-?[\d.]+/g);
        if (!n || n.length < 3) return null;
        var alfa = n.length > 3 ? parseFloat(n[3]) : 1;
        if (!(alfa >= 0.5)) return null;   /* casi transparente: no tapa, se sigue mirando */
        return [parseFloat(n[0]), parseFloat(n[1]), parseFloat(n[2])];
      };

      var luma = function (c) {
        return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
      };

      /* Devuelve la luma del primer fondo opaco que se encuentra en ese punto, y si el
         elemento que lo aporta es contenido real (no el body ni el html). */
      var muestra = function (x, y) {
        var pila;
        try { pila = document.elementsFromPoint(x, y); } catch (e) { return null; }
        if (!pila || !pila.length) return null;
        for (var i = 0; i < pila.length; i++) {
          var el = pila[i];
          if (!el || el.nodeType !== 1) continue;
          if (el === envRemate || envRemate.contains(el)) continue;   /* el propio encabezado */
          var raizDoc = (el === document.body || el === document.documentElement);
          if (!raizDoc && el.contains(envRemate)) continue;           /* ancestro del encabezado */
          var cs;
          try { cs = getComputedStyle(el); } catch (e) { continue; }
          if (!raizDoc && cs.position === 'fixed') continue;          /* chat, banner de cookies */
          var col = aRgb(cs.backgroundColor);
          if (col) return { l: luma(col), real: !raizDoc };
        }
        return null;
      };

      var estado = envRemate.getAttribute('data-mc-fondo') || 'claro';
      var ultimaY = -9999;

      /* Devuelve true si la medida se apoyo en contenido real, no solo en el body.
         Mientras sea false, el observador de mas abajo sigue esperando. */
      var evaluar = function () {
        var caja = envRemate.getBoundingClientRect();
        var y = caja.bottom + 3;
        if (caja.bottom <= 0 || y >= window.innerHeight) return false;  /* fuera de pantalla */
        var ancho = window.innerWidth || document.documentElement.clientWidth;
        var xs = [Math.max(2, ancho * 0.12), ancho * 0.5, Math.min(ancho - 2, ancho * 0.88)];
        var suma = 0, n = 0, real = false;
        for (var i = 0; i < xs.length; i++) {
          var m = muestra(Math.round(xs[i]), Math.round(y));
          if (!m) continue;
          suma += m.l;
          n++;
          if (m.real) real = true;
        }
        if (!n) return false;
        var l = suma / n;
        var nuevo = estado;
        if (estado === 'claro' && l < corte - margen) nuevo = 'oscuro';
        else if (estado === 'oscuro' && l > corte + margen) nuevo = 'claro';
        if (nuevo !== estado) {
          estado = nuevo;
          envRemate.setAttribute('data-mc-fondo', estado);
        }
        return real;
      };

      var marcarListo = function () {
        if (!envRemate.hasAttribute('data-mc-fondo-listo')) {
          envRemate.setAttribute('data-mc-fondo-listo', '');
        }
      };

      /* Re-medicion al hacer scroll y al cambiar de tamano. Se acota de dos maneras para
         que no cueste nada: un solo calculo por fotograma, y solo si el scroll se movio
         mas de 24 px desde la ultima medida (leer elementsFromPoint fuerza al navegador a
         recalcular la maquetacion, asi que no conviene hacerlo 60 veces por segundo). */
      var pendiente = false;
      var repasar = function (forzar) {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var y = window.scrollY || 0;
          if (forzar !== true && Math.abs(y - ultimaY) < 24) return;
          ultimaY = y;
          evaluar();
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', marcarListo, { once: true });
      } else {
        marcarListo();
      }
      window.addEventListener('scroll', function () { repasar(false); }, { passive: true });
      window.addEventListener('resize', function () { repasar(true); });
      /* En el editor de temas, al mover o editar cualquier seccion cambia lo que hay
         debajo del encabezado, asi que hay que volver a mirar. */
      document.addEventListener('shopify:section:load', function () { repasar(true); });
      document.addEventListener('shopify:section:unload', function () { repasar(true); });
      document.addEventListener('shopify:section:reorder', function () { repasar(true); });
    } else if (envRemate) {
      /* Modos manuales: el valor ya viene puesto desde Liquid y no se toca. Se marca
         listo igualmente para que las transiciones queden disponibles. */
      envRemate.setAttribute('data-mc-fondo-listo', '');
    }
  } catch (e) {
    console.warn('[MIcase] micase-header: no se pudo adaptar el remate inferior al fondo de abajo', e);
  }
})();
